/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { toCamelCase } from "utils/Utils";

const GlHeadEdit = ({ classes }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { rowData } = location.state || {};
  const [code, setCode] = useState("");
  const [codeState, setCodeState] = useState(false);
  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const [description, setDescription] = useState("");
  const [descriptionState, setDescriptionState] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  useEffect(() => {
    (async () => {
      if (rowData?.name) {
        setCode(rowData?.code);
        setName(rowData?.name);
        setDescription(rowData?.description);
      }
    })();
  }, []);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (code === "") {
      setCodeState(true);
    } else {
      setCodeState(false);
    }
    if (name === "") {
      setNameState(true);
    } else {
      setNameState(false);
    }
    if (description === "") {
      setDescriptionState(true);
    } else {
      setDescriptionState(false);
    }
    if (code && name && description) {
      return true;
    } else {
      return false;
    }
  };

  const saveGlHeadInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      code: code,
      name: name,
      description: description ? description : "",
    };
    const res = await apiHandler({
      url: endpoint.GL_HEAD_UPDATE_BY_ID + rowData?.id,
      method: "PUT",
      authToken: authToken,
      data: bulkData,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };

  const handlestructureSubmit = async (event) => {
    // if (isValidated()) {
      // toastUpdate("", "", false);

      let status = await saveGlHeadInformation();
      if (status === "SUCCESS") {
        const msg = "GL-Head updated successfully!"
          toastUpdate("Success", msg, true);
        setRedirectURL(`/coreservice/GLHead`);
      }
    // }
  };

  const handlecancelstructure = () => {
    navigate("/coreservice/GLHead");
  };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SubHeader
            label={"Edit GL-Head"}
            button1=" Save"
            button2=" Cancel"
            button1click={handlestructureSubmit}
            button2click={handlecancelstructure}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="lp_branch_name"
              value={toCamelCase(name) || ""}
              setState={setName}
              setError={setNameState}
              disabled
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Code"
              required
              error={codeState}
              id="lp_branch_code"
              type="code"
              value={code || ""}
              setState={setCode}
              setError={setCodeState}
              disabled={Boolean(rowData?.code)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Description"
                required
                id="lp_branch_parent_code"
                value={description || ""}
                setState={setDescription}
                error={descriptionState}
                setError={setDescriptionState}
              />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default GlHeadEdit;
